import { render, staticRenderFns } from "./AgencySwitch.vue?vue&type=template&id=789e3349"
import script from "./AgencySwitch.vue?vue&type=script&lang=ts"
export * from "./AgencySwitch.vue?vue&type=script&lang=ts"
import style0 from "./AgencySwitch.vue?vue&type=style&index=0&id=789e3349&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports